import { FormNodeVolunteerDepartmentsModel } from '../../../../../shared/volunteer/form';
import { AbstractElementEditor } from './AbstractElementEditor';

export class VolunteerDepartmentsEditor extends AbstractElementEditor<FormNodeVolunteerDepartmentsModel> {
  public getDescription(): string {
    return 'Volunteer department selection';
  }

  public getName(): string {
    return 'Volunteer Departments';
  }

  public getIcon(): string {
    return 'group';
  }
}
